import React from 'react';
import classNames from 'classnames';

import style from './style.css';


export default class FormGroup extends React.Component {

  render() {
    let {className} = this.props;
    className = classNames(className, style.formGroup);

    return <div {...this.props} ref="self" className={className} />;
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/form-group.js